import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const Header = {
	init() {
		const header = document.querySelector('header');
		setTimeout(() => {
			document.body.classList.add('ready');
		}, 100);

		ScrollTrigger.create({
			start: 'top top',
			end: 99999,
			onUpdate: (self) => {
				if (self.direction === -1) {
					document.body.classList.remove('hide-headers');
				} else {
					document.body.classList.add('hide-headers');
				}
			},
		});

		ScrollTrigger.create({
			start: '10px top',
			end: 99999,
			onToggle: (self) => document.body.classList.toggle('scrolling'),
		});

		let scrollto = document.querySelectorAll('#property-nav a');
		scrollto.forEach((scroll) => {
			scroll.addEventListener('click', function (e) {
				// scroll one page down
				if (/#/.test(scroll.href)) {
					console.log(scroll.href);
					e.preventDefault();
					const _section = document.querySelector(
						'#' + scroll.href.split('#')[1]
					);
					console.log(_section);
					if (_section) {
						window.scrollTo({
							top: _section.offsetTop,
							behavior: 'smooth',
						});
					} else {
						const _section2 = document.querySelector(
							'.wp-block-group.' + scroll.href.split('#')[1]
						);
						window.scrollTo({
							top: _section2.offsetTop - 150,
							behavior: 'smooth',
						});
					}
				}
			});
		});
		// Handle goto links in property nav
		if (document.body.classList.contains('page-floorplans')||
			document.body.classList.contains('page-availabilities') ||
			document.body.classList.contains('page-unit')) {
			// Handle all availability links on these pages

			if(document.body.classList.contains('page-floorplans') ){
				const availabilityLinks = document.querySelectorAll('a[data-goto="availability"]');
				availabilityLinks.forEach(link => {
					link.addEventListener('click', function(e) {
						e.preventDefault();
						
						// Wait a bit for any dynamic content to load
						setTimeout(() => {
							const propertyFilters = document.querySelector('#page');
							if (propertyFilters) {
								// Add a small offset to account for fixed headers
								const offset = 100;
								window.scrollTo({
									top: propertyFilters.offsetTop - offset,
									behavior: 'smooth'
								});
							} else {
								console.warn('Property filters section not found');
							}
						}, 100);
					});
				});

			}
			
			
			// Handle other goto links in property nav
			const propertyNavLinks = document.querySelectorAll('#property-nav a[data-goto]:not([data-goto="availability"])');
			propertyNavLinks.forEach(link => {
				console.log(link);
				link.addEventListener('click', function(e) {
					console.log(this);
					const gotoValue = this.getAttribute('data-goto');
					if (gotoValue) {
						e.preventDefault();
						sessionStorage.setItem('scrollToSection', gotoValue);
						window.location.href = this.href;
					}
				});
			});
		}



		// Add this right after your existing code (around line 68)
		// Handle stored navigation on page load
		const handleStoredNavigation = () => {
			const storedSection = sessionStorage.getItem('scrollToSection');
			if (storedSection) {
				sessionStorage.removeItem('scrollToSection');
				
				setTimeout(() => {
					// Special handling for availability section - scroll to property_filters
					if (storedSection === 'availability') {
						// Wait a bit more for dynamic content to load
						setTimeout(() => {
							const propertyFilters = document.querySelector('#page');
							if (propertyFilters) {
								// Add a small offset to account for fixed headers
								const offset = 100;
								window.scrollTo({
									top: propertyFilters.offsetTop - offset,
									behavior: 'smooth'
								});
							}
						}, 200);
					} else {
						const targetElement = document.querySelector(`#${storedSection}`) || 
											document.querySelector(`.wp-block-group.${storedSection}`);
						
						if (targetElement) {
							if (targetElement.id) {
								window.scrollTo({
									top: targetElement.offsetTop,
									behavior: 'smooth'
								});
							} else {
								window.scrollTo({
									top: targetElement.offsetTop - 150,
									behavior: 'smooth'
								});
							}
							// Find and update the active property nav link
							const propertyNavLinks = document.querySelectorAll('#property-nav a');
							propertyNavLinks.forEach(link => {
								if (link.getAttribute('href') === '#' + storedSection) {
									link.classList.add('current_page_item');
								}
							});
						}
					}
				}, 500);
			}
		};

		// Call this when DOM is ready
		document.addEventListener('DOMContentLoaded', handleStoredNavigation);

		const hamburger = document.querySelector('.hamburger');
		if (hamburger) {
			hamburger.addEventListener('click', function () {
				// document.body.classList.toggle('nav-open');
				if (document.body.classList.contains('nav-open')) {
					document.body.classList.remove('nav-open');
					document.body.classList.add('nav-closing');

					setTimeout(() => {
						document.body.classList.remove('nav-closing');
					}, 800);
				} else {
					document.body.classList.add('nav-open');
				}
			});
		}
		const navitems = document.querySelectorAll('.hamburger-nav a');
		navitems.forEach((item) => {
			item.addEventListener('click', function () {
				// console.log(2);
				document.body.classList.remove('nav-open');
				document.body.classList.add('nav-closing');
				setTimeout(() => {
					document.body.classList.remove('nav-closing');
				}, 2000);
			});
		});
		// const promobanner = document.querySelector('.promo-banner');
		// if (promobanner) {
		// 	const button = promobanner.querySelector('svg');
		// 	button.addEventListener('click', function () {
		// 		// promobanner.style.display = 'none';
		// 		promobanner.remove();
		// 	});
		// }
		const menuItem = document.querySelectorAll('.current-menu a');
		for (var i = 0; i < menuItem.length; i++) {
			menuItem[i].addEventListener('click', function () {
				// console.log('okay');
				// remove active class for all elements
				for (var i = 0; i < menuItem.length; i++) {
					menuItem[i].classList.remove('current_page_item');
					menuItem[i].classList.remove('active');
				}
				// add active to clicked element
				this.classList.add('current_page_item');
			});
		}

		// document.addEventListener('DOMContentLoaded', function () {
			const promoBanner = document.querySelector('.promo-banner');
			const mainHeader = document.getElementById('main-header');
			const propertyNav = document.getElementById('property-nav');
			const body = document.body;
			const floorplanHero = document.querySelector('body.page-floorplans .wp-block-group.hero-group');
			const availabilitiesHero = document.querySelector('body.page-availabilities .wp-block-group.hero-group');
			const unitHero = document.querySelector('body.page-unit .wp-block-group.hero-group');

			
			// Update hero padding-top function for floorplans, availabilities, and unit pages
			const updateHeroPadding = () => {
				// Update floorplanHero padding-top
				if (floorplanHero) {
					let totalHeight = 0;
					
					// Add promoBanner height if it exists and is visible
					if (promoBanner && promoBanner.offsetHeight > 0) {
						totalHeight += promoBanner.offsetHeight;
					}
					
					// Add mainHeader height if it exists
					if (mainHeader) {
						totalHeight += mainHeader.offsetHeight;
					}
					
					// Add propertyNav height if it exists
					if (propertyNav) {
						totalHeight += propertyNav.offsetHeight;
					}
					
					// Add extra 100px padding if screen width is above 820px
					if (window.innerWidth > 820) {
						totalHeight += 50;
					}
					
					floorplanHero.style.paddingTop = `${totalHeight}px`;
				}

				// Update availabilitiesHero padding-top
				if (availabilitiesHero) {
					let totalHeight = 0;
					
					// Add promoBanner height if it exists and is visible
					if (promoBanner && promoBanner.offsetHeight > 0) {
						totalHeight += promoBanner.offsetHeight;
					}
					
					// Add mainHeader height if it exists
					if (mainHeader) {
						totalHeight += mainHeader.offsetHeight;
					}
					
					// Add propertyNav height if it exists
					if (propertyNav) {
						totalHeight += propertyNav.offsetHeight;
					}
					
					// Add extra 100px padding if screen width is above 820px
					if (window.innerWidth > 820) {
						totalHeight += 50;
					}
					
					availabilitiesHero.style.paddingTop = `${totalHeight}px`;
				}

				// Update unitHero padding-top
				if (unitHero) {
					let totalHeight = 0;
					
					// Add promoBanner height if it exists and is visible
					if (promoBanner && promoBanner.offsetHeight > 0) {
						totalHeight += promoBanner.offsetHeight;
					}
					
					// Add mainHeader height if it exists
					if (mainHeader) {
						totalHeight += mainHeader.offsetHeight;
					}
					
					// Add propertyNav height if it exists
					if (propertyNav) {
						totalHeight += propertyNav.offsetHeight;
					}
					
					// Add extra 100px padding if screen width is above 820px
					if (window.innerWidth > 820) {
						totalHeight += 50;
					}
					
					unitHero.style.paddingTop = `${totalHeight}px`;
				}
			};

			if (promoBanner && mainHeader) {
				const updateOffsets = () => {
					const height = promoBanner.offsetHeight;

					if (window.innerWidth > 820) {
						if (body.classList.contains('hide-headers')) {
							mainHeader.style.transform = `translateY(-100px)`;
						} else if (body.classList.contains('ready')) {
							mainHeader.style.transform = `translateY(${height}px)`;
						}

						if (propertyNav) {
							if (body.classList.contains('hide-headers')) {
								propertyNav.style.top = `${height}px`;
							} else {
								propertyNav.style.top = `${height + mainHeader.offsetHeight}px`;
							}
						}
					} else {
						mainHeader.style.transform = `translateY(${height}px)`;

						if (propertyNav) {
							const propertyNavHeight = propertyNav.offsetHeight;
							if (body.classList.contains('hide-headers')) {
								propertyNav.style.top = `${height + mainHeader.offsetHeight - propertyNavHeight}px`;
							} else {
								propertyNav.style.top = `${height + mainHeader.offsetHeight}px`;
							}
						}
					}

					// Update floorplanHero padding-top
					updateHeroPadding();
				};

				const handleResize = () => updateOffsets();
				const handleScroll = () => updateOffsets();

				window.addEventListener('resize', handleResize);
				window.addEventListener('scroll', handleScroll);

				const observer = new ResizeObserver(updateOffsets);
				observer.observe(promoBanner);

				updateOffsets();
				setTimeout(() => {
					updateOffsets();
				}, 200);

				const button = promoBanner.querySelector('svg');
				if (button) {
					button.addEventListener('click', () => {
						promoBanner.remove();

						// Remove inline styles
						mainHeader.style.transform = '';
						if (propertyNav) {
							propertyNav.style.top = '';
						}

						// Update floorplanHero padding-top after promo banner removal
						updateHeroPadding();

						// Stop observing
						observer.disconnect();
						window.removeEventListener('resize', handleResize);
						window.removeEventListener('scroll', handleScroll);
					});
				}
			}

			// Set up hero padding event listeners for floorplans, availabilities, and unit pages
			if (floorplanHero || availabilitiesHero || unitHero) {
				const handleHeroResize = () => updateHeroPadding();

				window.addEventListener('resize', handleHeroResize);

				// Initial call
				updateHeroPadding();
				setTimeout(() => {
					updateHeroPadding();
				}, 200);

				// Set up observers for dynamic content changes
				if (mainHeader) {
					const headerObserver = new ResizeObserver(updateHeroPadding);
					headerObserver.observe(mainHeader);
				}

				if (propertyNav) {
					const navObserver = new ResizeObserver(updateHeroPadding);
					navObserver.observe(propertyNav);
				}

				if (promoBanner) {
					const promoObserver = new ResizeObserver(updateHeroPadding);
					promoObserver.observe(promoBanner);
				}
			}
		// });
	},
};

export default Header;
